import { Input, makeStyles } from "@fluentui/react-components";
import { useEffect, useState } from "react";

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  style,
  ...props
}: {
  value: string;
  onChange: (value: string) => void;
  debounce?: number;
  [key: string]: any;
}) {
  const styles = useStyles();
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <Input
      {...props}
      value={value}
      onChange={(_e, data) => setValue(data.value)}
      className={styles.input}
      data-testid="debounced-input"
      style={{
        ...style,
        width: "100%",
      }}
    />
  );
}

const useStyles = makeStyles({
  input: {
    "& input": {
      fontStyle: "italic",
      width: "100%",
    },
    marginBottom: "10px",
  },
});
